module.exports = __webpack_public_path__ + "img/1F1E7-1F1F4.2bf3643f.svg";